export default "__VITE_ASSET__tdlxd9fb__"